<template>
    <main-layout>
        <div class="d-flex" slot="header">
            <h2 class="flex-grow-1">Offices</h2>
            <div>
                <el-button type="primary" size="small" @click="onShowAdd">New Office</el-button>
            </div>
        </div>
        <section class="page-section">
            <el-table :data="dataList" :loading="loading" @selection-change="onSelectionChange">
                <el-table-column width="45" type="selection"/>
                <el-table-column prop="name" width="200" label="Name"/>
                <el-table-column prop="tel" width="200" label="Tel"/>
                <el-table-column prop="email" width="200" label="Email"/>
                <el-table-column prop="formatted_address" label="Address"/>
                <el-table-column width="80" label="Options" align="right">
                    <template slot-scope="scope">
                        <a @click="onShowEdit(scope.row)">Edit</a>
                    </template>
                </el-table-column>
            </el-table>
            <div class="tablenav-bottom">
                <div class="table-actions">
                    <el-button size="small" type="primary" :disabled="selectionIds.length===0" @click="onDelete">
                        Batch Delete
                    </el-button>
                </div>
                <el-pagination
                        background
                        layout="prev, pager, next, total"
                        :total="total"
                        :page-size="pageSize"
                        :current-page="page"
                        @current-change="onPageChange"
                />
            </div>
        </section>
        <el-dialog title="New Office" closeable :visible.sync="showDialog" :close-on-click-modal="false"
                   :close-on-press-escape="false">
            <el-form size="medium" label-width="120px">
                <el-form-item label="Name">
                    <el-input size="medium" class="w300" v-model="office.name"/>
                </el-form-item>
                <el-form-item label="Tel">
                    <el-input size="medium" class="w300" v-model="office.tel"/>
                </el-form-item>
                <el-form-item label="Email">
                    <el-input size="medium" class="w400" v-model="office.email"/>
                </el-form-item>
                <el-form-item label="City">
                    <el-input size="medium" class="w300" v-model="office.city"/>
                </el-form-item>
                <el-form-item label="Province">
                    <el-input size="medium" class="w300" v-model="office.province"/>
                </el-form-item>
                <el-form-item label="Country">
                    <el-input size="medium" class="w300" v-model="office.country"/>
                </el-form-item>
                <el-form-item label="Address">
                    <el-input size="medium" class="w400" v-model="office.address_1"/>
                </el-form-item>
                <el-form-item label="Unit Number">
                    <el-input size="medium" class="w100" v-model="office.unit_number"/>
                </el-form-item>
                <el-form-item label="Postal Code">
                    <el-input size="medium" class="w100" v-model="office.postal_code"/>
                </el-form-item>
                <el-form-item label="Sort">
                    <el-input size="medium" class="w100" v-model="office.sort_num"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">{{$t('common.submit')}}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </main-layout>
</template>

<script>
import ApiService from "../utils/ApiService";
import Pagination from "../mixins/Pagination";

export default {
    name: "OfficeList",
    mixins: [Pagination],
    data() {
        return {
            office: {},
            showDialog: false,
        }
    },
    methods: {
        listApi() {
            return '/sterling/offices';
        },
        resetData() {
            this.office = {
                sort_num: 0,
                country: 'CA',
                province: 'BC',
            };
        },
        onDelete() {
            this.$confirm('This will permanently delete the selected items. Continue?', 'Confirm', {
                type: 'warning'
            }).then(() => {
                let ids = this.selectionIds.map((d) => d.id);
                ApiService.delete('/sterling/offices/batch', {data: {ids}}).then(() => {
                    this.fetchList();
                });
            });
        },
        onSubmit() {
            let {office} = this;
            if (!office.name) {
                this.$message.error('Please Enter Name');
                return false;
            }

            if (office.id) {
                ApiService.put('/sterling/offices/' + office.id, office).then(() => {
                    this.resetData();
                    this.fetchList();
                    this.showDialog = false;
                    this.$message.success('Office Update Success');
                });
            } else {
                ApiService.post('/sterling/offices', office).then(() => {
                    this.resetData();
                    this.fetchList();
                    this.showDialog = false;
                    this.$message.success('Office Save Success');
                });
            }
        },
        onShowAdd() {
            this.resetData();
            this.showDialog = true;
        },
        onShowEdit(d) {
            this.office = d;
            this.showDialog = true;
        },
    },
    mounted() {
        this.fetchList();
    },
}
</script>

<style scoped>

</style>
